// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16CLJ","top":"styles_top__1CAHx"};